import {
  CustomerTenantGuestGroup,
  OrderFormat,
  ServiceTime,
} from '@ancon/wildcat-types'

type OutletMenuFetchKeyParams = {
  outletId?: string | null
  menuTreeId?: string | null
  orderFormat?: OrderFormat | null
  serviceTime?: ServiceTime | null
  guestGroups?: CustomerTenantGuestGroup[] | null
}

/**
 * Identifies an outlet menu fetch by everything the resulting menu depends on,
 * so the same menu is not requested again while none of it has changed.
 */
export default function getOutletMenuFetchKey({
  outletId,
  menuTreeId,
  orderFormat,
  serviceTime,
  guestGroups,
}: OutletMenuFetchKeyParams) {
  const guestGroupsKey = (guestGroups || [])
    .map(({ tenantId, guestGroupId }) => `${tenantId}:${guestGroupId}`)
    .sort()
    .join(',')

  return [
    outletId || '',
    menuTreeId || '',
    orderFormat ?? '',
    serviceTime?.kind ?? '',
    serviceTime?.time ?? '',
    guestGroupsKey,
  ].join('|')
}
